/**
 * Reader appearance — colour palettes and light/dark/system mode.
 *
 * Single source of truth for both sides: the API validates writes against
 * `themePalettes`/`themeModes`, and the web client renders the picker from
 * `THEME_PALETTE_SWATCHES` and paints via `data-theme-palette` / `data-theme`
 * on <html>.
 *
 * Adding a palette means: one id here, one entry in the generator source in
 * `apps/web/scripts/generate-palettes.mjs` (then re-run it), and two i18n keys.
 * Nothing else — the API allowlist and the picker both derive from this list.
 */
export const themePalettes = [
    'classic',
    'moss',
    'ember',
    'terracotta',
    'lakeside',
    'sand',
    'orchid',
    'botanical',
];
export const themeModes = ['light', 'dark', 'system'];
/**
 * The three source colours each palette was derived from, in the order they
 * were specified. Shown as swatches in the picker — these are the original
 * trio, not the derived UI tokens, so the picker shows what the palette *is*
 * rather than the three tokens that happen to be most visible.
 */
export const THEME_PALETTE_SWATCHES = {
    classic: ['#0F172A', '#64748B', '#F1F5F9'],
    moss: ['#576238', '#FFD95D', '#F0EADC'],
    ember: ['#EE6C29', '#282B2B', '#7AA6B3'],
    terracotta: ['#CF8852', '#E8E7E3', '#525333'],
    lakeside: ['#6D8EC5', '#D3622C', '#F0C845'],
    sand: ['#6F6134', '#E1C68F', '#FAE7C9'],
    orchid: ['#3D402F', '#FCF9D8', '#C99FCD'],
    botanical: ['#69A481', '#E7EDEB', '#7C1F31'],
};
/**
 * What a user sees before they ever open the picker. `classic` reproduces the
 * pre-palette look, so existing installs are visually unchanged on upgrade;
 * `system` follows the OS, which is what the app did before via a bare
 * `prefers-color-scheme` media query.
 */
export const DEFAULT_THEME_PALETTE = 'classic';
export const DEFAULT_THEME_MODE = 'system';
export function isThemePalette(value) {
    return themePalettes.includes(value);
}
export function isThemeMode(value) {
    return themeModes.includes(value);
}
//# sourceMappingURL=appearance.js.map